import {Component, Input, OnInit} from '@angular/core';
import {Registration} from '../../datamodel/registration';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  @Input()
  registration: Registration;

  constructor() { }

  ngOnInit() {
  }

}
